/* globals apiConn, $ */
const React = require('react');

let Entry = React.createClass({
  propTypes: {
    item: React.PropTypes.object
  },

  getInitialState: function () {
    return { };
  },

  componentDidMount: function () {

  },

  componentWillUnmount: function () {

  },

  render () {
    const article = this.props.item;

    const link = article['link'];
    const author_slug = article['author_slug'];
    const entry_slug = article['slug'];

    let img_crop = '';
    if (article['img_crop'] === 'no') {
      img_crop = '-anpassad';
    }

    const img_id = article['img_id'];
    const slug = article['slug'];

    const author_id = article['author'];
    const title = article['title'];

    const thumbnailStyle = {
      'backgroundImage': 'url(/bilder/' + link + '-stor' + img_crop + '/' + img_id + '/' + slug + '.jpg)'
    };

    const avatarStyle = {
      'backgroundImage': 'url(/bilder/profil-liten/' + author_id + '/' + author_slug + '.jpg)'
    };

    const path = '/' + link + '/' + author_slug + '/' + entry_slug;

    return (
      <div className='article-list-item l-grid__item lap-u-width-one-half desk-u-width-one-third u-margin-b-m'>
        <div className='card card-recipe'>
          <a href={path}>
            <div className='card-thumbnail theme-light u-margin-b-s'>
              <div className='card-thumbnail__image' style={thumbnailStyle}></div>
              <div className='avatar card-recipe-avatar' style={avatarStyle}></div>
            </div>
            <div className='u-text-center u-padding-a-m'>
              <p className='u-margin-a-n u-truncate'>{title}</p>
            </div>
          </a>
        </div>
      </div>
    );
  }
});

let EntryType = React.createClass({
  propTypes: {
    items: React.PropTypes.array
  },

  getInitialState: function () {
    return { };
  },

  componentDidMount: function () {

  },

  componentWillUnmount: function () {

  },

  getTypeTitle: function(){
    let out = '';

    const type = this.props.items[0].type;

    switch (type) {
      case 'recipe':
        out = 'recept';
        break;
      case 'article':
        out = 'artiklar';
        break;
    }

    return out;
  },

  render () {
    const type = this.getTypeTitle();

    const entries = [];

    for (let a = 0; a < this.props.items.length; a++) {
      const item = this.props.items[a];
      var key = 'type_entry_' + item.id;
      entries.push(<Entry item={item} key={key}/>);
    }

    return (
      <div className='container u-padding-t-l'>
        <h1 className='title-medium u-text-center u-padding-b-m'>Sparade {type}</h1>
        <div className='u-padding-b-m'>
          <div className='divider'></div>
        </div>
          <div className='l-grid'>
            {entries}
          </div>
      </div>
    );
  }
});

let MyPages = React.createClass({
  propTypes: {
  },

  getInitialState: function () {
    return { articles: null };
  },

  componentDidMount: function () {
    this.loadData();
  },

  loadData: function () {
    const userId = $.cookie('_uid');

    let cachefix = (new Date()).getTime() + '_' + Math.round(Math.random() * 100000);

    const indata = {
      filters: {
        nolimit: true,
        sort: 'fe_saved_entries.`stamp`',
        order: 'DESC',
        saved: userId,
        cacheFix: cachefix
      }
    };

    var options = { nocache: true };

    apiConn.doCallOptions('entryhandler', 'query', indata, options, (status, data) => {
      if (status) {
        this.setState({ articles: data });
      }
    });
  },

  componentWillUnmount: function () {

  },

  render () {
    let out = null;

    if (this.state.articles) {
      if (this.state.articles.total && this.state.articles.total > 0) {
        const articlesOut = [];

        const articles = this.state.articles;

        const typeList = {};

        for (let i = 0; i < articles['data'].length; i++) {
          let article = articles['data'][i];
          let type = article['type'];

          if (!typeList[type]) {
            typeList[type] = [];
          }
          typeList[type].push(article);
        }

        const typeOrder = ['recipe', 'article'];

        for (let i = 0; i < typeOrder.length; i++) {
          let type = typeOrder[i];
          let list = typeList[typeOrder[i]];

          let key = type + '_list';

          if (list) {
            articlesOut.push(<EntryType key={key} items={list} />);
          }
        }

        out = (
          <div>{articlesOut}</div>
        );
      } else {
        out = (
          <div className='u-text-align-left u-padding-b-l u-padding-t-l u-padding-l-l u-padding-r-l v3-background'>
            <p>Hej käre medlem,</p>
            <p>Här kan du spara alla dina favoritrecept så att du hittar dem snabbt. Som medlem kommer du också få tillgång till vårt nyhetsbrev med recept och inspiration inför helgen.</p>
            <p>Klicka dig in på ett recept som du tycker ser spännande ut och tryck på spara så hamnar det här nästa gång du loggar in.</p>
            <p>Smaklig måltid!</p>
          </div>
        );
      }
    } else {
      out = <div></div>;
    }

    return out;
  }
});

module.exports = MyPages;



// WEBPACK FOOTER //
// ./src/scripts/components/mypages.js